import React, { useEffect, useState } from "react";
import styles from "./ViewContact.module.css";
import { Modal, Box, FormControl, Select, MenuItem } from "@mui/material";
import NewFormTextInput from "../FormTextInput/NewFormTextInput";
import CountryCodePhoneInput from "../CountryCodePhoneInput/CountryCodePhoneInput";
import AutoCompleteField from "../AutoCompleteField/AutoCompleteField";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../RolePermissionAccess/RolePermissionAccess";
import { ErrorType } from "../FormTextInput/types";
import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import SourceManager from "../SourceManager/SourceManager";
import FlagAssign from "../FlagAssign/FlagAssign";
import UserAssign from "../UserAssign/UserAssign";
import {
  getCombinedAssignees,
  getCountryCodeFromCallingCode,
} from "../CommonFunctions/CommonFunctions";
import AdditionalFields from "../../pages/app/Nurture/components/AddLead/AdditionalFields";
import CancelBtn from "../Buttons/CancelBtn";
import SaveBtn from "../Buttons/SaveBtn";
import {
  contactToLead,
  resetContactModalState,
} from "../../pages/app/Manage/InstituteProfile/service/instituteSlice";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../ToastNotification/service/toastNotificationSlice";
import { useAuthUser } from "react-auth-kit";
import StaffSkeleton from "../Skeletons/StaffSkeleton";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: "65%",
    xl: "65%",
    md: "65%",
  },
  maxHeight: "80vh",
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

function ViewContact() {
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const hasContactsAccess = getSubDomainAccessStatus(
    "INBOUND",
    "CONTACTS",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const { leadBoard } = useSelector((state: any) => state.nurture);
  const swimlaneData = leadBoard?.swimlaneData;
  const leadStages =
    swimlaneData &&
    [...swimlaneData]?.sort((a: any, b: any) => {
      return a?.orderIndex - b?.orderIndex;
    });
  const { courses } = useSelector((state: any) => state.courses);
  const { branchList } = useSelector((state: any) => state.branch);
  const { staffList } = useSelector((state: any) => state.staff);
  const sourceList = leadBoard?.sourceList;
  const { batchList } = useSelector((state: any) => state.batch);
  const {
    instituteDetails,
    contactById,
    contactModalState,
    convertToLeadLoading,
    convertToLeadSuccess,
    contactByIdLoading,
  } = useSelector((state: any) => state.institute);
  const { activeLeadForm } = useSelector((state: any) => state.appSettings);

  const [show, setShow] = useState<boolean>(false);

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [contactCountryCode, setContactCountryCode] = useState<string>("91");
  const [source, setSource] = useState<any>("");
  const [stage, setStage] = useState<any>("");
  const [priority, setPriority] = useState("NORMAL");
  const [assigny, setAssigny] = useState<any>("");
  const [selectedBatch, setSelectedBatch] = useState<any>("");
  const [selectedCourse, setSelectedCourse] = useState<any>("");
  const [selectedBranch, setSelectedBranch] = useState<any>("");
  const [additionalFields, setAdditionalFields] = useState<any[]>([]);

  const [validStateEmail, setValidStateEmail] = React.useState<boolean>(true);
  const [validStateLastName, setValidStateLastName] =
    React.useState<boolean>(true);
  const [validStateFirstName, setValidStateFirstName] =
    React.useState<boolean>(true);
  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const [validStateContact, setValidStateContact] =
    React.useState<boolean>(true);
  const [validStateCourse, setValidStateCourse] = React.useState<boolean>(true);
  const [validStateBranch, setValidStateBranch] = React.useState<boolean>(true);
  const [isValidSource, setIsValidSource] = useState(false);

  const setValidateStatusEmail = React.useCallback((val: boolean) => {
    setValidStateEmail(val);
  }, []);
  const setValidateStatusLastName = React.useCallback((val: boolean) => {
    setValidStateLastName(val);
  }, []);
  const setValidateStatusFirstName = React.useCallback((val: boolean) => {
    setValidStateFirstName(val);
  }, []);

  const filteredBranchList = hasAllBranchAccess
    ? branchList
    : branchList?.filter((branch: any) => branch.id === userById?.branchId);

  const filteredBatches = batchList?.filter((batch: any) => {
    const courseMatch =
      selectedCourse?.id === "" || batch.courseId === selectedCourse?.id;
    const branchMatch =
      selectedBranch?.id === "" || batch.branchId === selectedBranch?.id;
    const regularBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      batch.batchStatus !== "COMPLETED" &&
      batch.status === "ACTIVE";

    return courseMatch && branchMatch && regularBatch;
  });

  const combinedAssignees = getCombinedAssignees(staffList, selectedBranch?.id);

  const onCourseChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedCourse(value);
        setSelectedBatch("");
      } else {
        setSelectedCourse("");
        setSelectedBatch("");
      }
      setValidStateCourse(true);
    },
    []
  );

  const onStageChange = React.useCallback(
    (event: any) => {
      setStage(event.target.value);
    },
    [setStage]
  );

  const onBranchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedBranch(value);
        setSelectedBatch("");
        setValidStateBranch(true);
      } else {
        setSelectedBranch("");
        setSelectedBatch("");
        setValidStateBranch(false);
      }
    },
    []
  );

  const onBatchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedBatch(value);
        //  setValidStateBatchName(true);
      } else {
        setSelectedBatch("");
        //  setValidStateBatchName(false);
      }
    },
    []
  );

  const onSourceChange = React.useCallback(
    (value: any | null) => {
      if (value !== null) {
        setIsValidSource(false);
        setSource(value);
      } else {
        setSource("");
      }
    },
    [setSource]
  );

  const handleLeadAssignee = React.useCallback(
    (leadId: any, user: any) => {
      setAssigny(user);
    },

    [setAssigny]
  );

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => {
      setPriority(leadPriority);
    },

    [setPriority]
  );
  const handleFieldChange = (updatedFields: any[]) => {
    setAdditionalFields(updatedFields);
  };

  const reset = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setContactCountryCode("91");
    setSelectedBatch("");
    setSelectedCourse("");
    setSelectedBranch("");
    setSource("");
    setStage("");
    setPriority("");
    setAssigny("");
    setValidStateEmail(true);
    setValidStateLastName(true);
    setValidStateFirstName(true);
    setShowErrMsz(true);
    setValidStateContact(true);
    setErrorType("client");
  };

  const onClose = () => {
    setShow(false);
    dispatch(resetContactModalState());
    reset();
  };

  function formatName(name: string) {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const AddLead = () => {
    let phoneFormated = phone;
    if (phone === contactCountryCode) {
      phoneFormated = "";
    }

    let body = {
      instituteId: authUser?.institute?.[0]?.instituteId,
      instituteName: authUser?.institute?.[0]?.instituteName,
      studentEmail: email,
      firstName: formatName(firstName),
      lastName: formatName(lastName),
      studentContact: phoneFormated,
      contactCountryCode: contactCountryCode,
      courseName: selectedCourse?.courseName,
      courseId: selectedCourse?.id,
      branchName: selectedBranch?.branchName,
      branchId: selectedBranch?.id,
      batchId: selectedBatch?.id ?? "",
      batchName: selectedBatch?.batchName ?? "",
      assignedToName: assigny?.firstName + " " + assigny?.lastName,
      assignedToId: assigny?.id,
      enquirySource: source?.key,
      enquiryStatus: stage?.stateName,
      enquiryStatusId: stage?.id,
      enquiryPriority: priority.toUpperCase(),
      studentContactId: contactById?.id,
      formId:
        contactById?.enquirySource === "WEBFORM"
          ? contactById?.webformId
          : contactById?.enquirySource === "META"
          ? contactById?.streamId
          : "",
      otherDetails: contactById?.otherDetails ?? [],
      createdById: authUser?.institute?.[0]?.id,
      checkDuplicate: true,
      createdByName: authUser?.firstName + " " + authUser?.lastName,
    };

    let emailReg = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,4})+$/;

    const countryCode = getCountryCodeFromCallingCode(contactCountryCode);
    const isPhoneNumberValid = isValidPhoneNumber(
      `+${phoneFormated}`,
      countryCode as CountryCode
    );

    try {
      if (!firstName) {
        dispatch(
          setToastNotification({
            message: String("Please enter first name"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateFirstName(false);
      } else if (phone === contactCountryCode && !email) {
        dispatch(
          setToastNotification({
            message: String("Please enter either phone number or email"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateContact(false);
        setValidStateEmail(false);
      } else if (email && !emailReg?.test(email)) {
        dispatch(
          setToastNotification({
            message: String("Please enter valid email"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        phone?.length > contactCountryCode?.length &&
        !isPhoneNumberValid
      ) {
        dispatch(
          setToastNotification({
            message: "Please enter valid phone number",
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!selectedCourse) {
        dispatch(
          setToastNotification({
            message: String("Please select course"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateCourse(false);
      } else if (!selectedBranch) {
        dispatch(
          setToastNotification({
            message: String("Please select branch"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateBranch(false);
      } else if (!source) {
        setIsValidSource(true);
        dispatch(
          setToastNotification({
            message: String("Please select source"),
            type: "error",
            snackOpen: true,
          })
        );
      }
      //    else if (!isValueInList) {
      //     dispatch(
      //       setToastNotification({
      //         message: String("Selected source does'nt exist in source list"),
      //         type: "error",
      //         snackOpen: true,
      //       })
      //     );
      //   }
      else if (!stage) {
        dispatch(
          setToastNotification({
            message: String("Please select stage"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!assigny) {
        dispatch(
          setToastNotification({
            message: String("Please select assignee"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!priority) {
        dispatch(
          setToastNotification({
            message: String("Please select priority"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        additionalFields?.length > 0 &&
        instituteDetails?.addLeadFormEnabled &&
        additionalFields.some((field) => field.required && !field.fieldValue)
      ) {
        const updatedFields = additionalFields?.map((field) => {
          if (field.required && !field.fieldValue) {
            return { ...field, isValid: false };
          }
          return field;
        });

        setAdditionalFields(updatedFields);
        dispatch(
          setToastNotification({
            message: String("Please fill required additional field"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        additionalFields.length > 0 &&
        instituteDetails?.addLeadFormEnabled &&
        additionalFields.some(
          (field) =>
            field.fieldType === "phone" && !field.isValid && !field.required
        )
      ) {
        dispatch(
          setToastNotification({
            message: String("Please fill valid phone number"),
            type: "error",
            snackOpen: true,
          })
        );
      } else {
        const enrichedPayload = {
          ...body,
          ...(additionalFields.length > 0 &&
            instituteDetails?.addLeadFormEnabled && {
              additionalInfo: additionalFields?.map((field) => ({
                fieldType: field.fieldType,
                fieldLabel: field.fieldName,
                fieldValue: field.fieldValue,
                options: field.options,
                required: field.required,
              })),
            }),
        };
        dispatch<any>(contactToLead(enrichedPayload));
      }
    } catch (error) {
      setErrorType("server");
    }
  };

  React.useEffect(() => {
    if (activeLeadForm?.[0]?.additionalFields?.length > 0) {
      const updatedFields = activeLeadForm?.[0]?.additionalFields?.map(
        (item: any, index: number) => ({
          fieldType: item?.field?.fieldType,
          fieldName: item?.field?.fieldName,
          fieldValue: "",
          options: item?.field?.options,
          required: item?.field?.required,
          index: index + 1,
          id: item?.id,
          isValid: true,
          disabled: hasContactsAccess ? false : true,
          countryCode: "",
        })
      );

      setAdditionalFields(updatedFields);
    }
  }, [activeLeadForm, contactModalState]);

  useEffect(() => {
    if (leadBoard && swimlaneData && leadStages?.length > 0) {
      setStage(leadStages[0]);
    }
  }, [setStage, leadBoard]);

  useEffect(() => {
    if (contactById) {
      setFirstName(contactById?.firstName?.replace(/[^a-zA-Z]/g, ""));
      setLastName(contactById?.lastName?.replace(/[^a-zA-Z]/g, ""));
      if (contactById?.contactNumber) {
        const isWebOrMeta =
          contactById?.enquirySource === "WEBFORM" ||
          contactById?.enquirySource === "META";

        const phoneNumber = isWebOrMeta
          ? contactById?.contactNumber
          : `${contactById?.contactNoCountryCode}${contactById?.contactNumber}`;
        setPhone(phoneNumber);
      }
      setEmail(contactById?.email);

      setContactCountryCode(contactById?.contactNoCountryCode);
      let defaultCourse = courses?.find(
        (course: any) => course?.id === contactById?.courseId
      );
      if (defaultCourse) {
        setSelectedCourse(defaultCourse);
      }
      let defaultBranch = branchList?.find(
        (branch: any) => branch?.id === contactById?.branchId
      );
      if (defaultBranch) {
        setSelectedBranch(defaultBranch);
      }
      let defaultBatch = batchList?.find(
        (batch: any) => batch?.id === contactById?.batchId
      );
      if (defaultBatch) {
        setSelectedBatch(defaultBatch);
      }

      const defaultAssigny = staffList?.find(
        (item: any) =>
          item.id === userById?.id && item.branchId === userById?.branchId
      );
      setAssigny(defaultAssigny);
      const contactSource =
        contactById?.enquirySource === "Excel Import"
          ? "EXCEL_IMPORT"
          : contactById?.enquirySource;
      const defaultSource = sourceList?.find(
        (item: any) => item.key === contactSource
      );
      setSource(defaultSource);
    }
  }, [
    contactById,
    courses,
    branchList,
    batchList,
    staffList,
    userById,
    sourceList,
  ]);

  useEffect(() => {
    if (convertToLeadSuccess !== true && convertToLeadSuccess !== false) {
      dispatch(resetContactModalState());
      reset();
    }
  }, [convertToLeadSuccess]);

  return (
    <div>
      <Modal
        open={contactModalState}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "999999" }}
      >
        <Box sx={style}>
          {contactByIdLoading ? (
            <div className={styles.viewContactSkeletonWrap}>
              <StaffSkeleton />
            </div>
          ) : (
            <>
              <div className={styles.viewContactWrap}>
                <div className={styles.viewContactTitle}>View Contact</div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      First name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusFirstName}
                      type={"text"}
                      id="firstName"
                      value={firstName}
                      onChange={(e: any) => {
                        const pattern = /^(?:[a-zA-Z\s]*[a-zA-Z][a-zA-Z\s]*)?$/;
                        if (pattern.test(e?.target?.value)) {
                          setFirstName(e?.target?.value);
                        }
                      }}
                      error={!validStateFirstName}
                      showErrorMessage={showErrMsz}
                      errorType={errorType}
                      autoComplete="true"
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Last name
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusLastName}
                      type={"text"}
                      id="lastName"
                      value={lastName}
                      onChange={(e: any) => {
                        const pattern = /^(?:[a-zA-Z\s]*[a-zA-Z][a-zA-Z\s]*)?$/;
                        if (pattern.test(e?.target?.value)) {
                          setLastName(e?.target?.value);
                        }
                      }}
                      error={lastName !== "" ? !validStateLastName : false}
                      showErrorMessage={lastName !== "" ? showErrMsz : false}
                      errorType={errorType}
                      autoComplete="true"
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Email Address
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusEmail}
                      type={"email"}
                      id="instituteEmail"
                      value={email}
                      onChange={(e: any) => {
                        setShowErrMsz(true);
                        setEmail(e?.target?.value.toLowerCase());
                        setValidStateContact(true);
                      }}
                      error={!validStateEmail}
                      showErrorMessage={showErrMsz}
                      errorType={errorType}
                      autoComplete="true"
                      require={false}
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Phone Number
                    </div>
                    <CountryCodePhoneInput
                      value={phone}
                      onChange={(event: any, country: any) => {
                        if (!phone.startsWith(country.dialCode)) {
                          setPhone(country.dialCode);
                        } else {
                          setPhone(event);
                        }
                        setContactCountryCode(country.dialCode);
                        if (event === country.dialCode || event === "") {
                          setValidStateContact(true);
                        } else {
                          setValidStateContact(
                            isValidPhoneNumber(
                              `+${country.dialCode}${event.replace(
                                country.dialCode,
                                ""
                              )}`,
                              country.countryCode.toUpperCase()
                            )
                          );

                          setValidStateEmail(true);
                        }
                      }}
                      error={validStateContact}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>

                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Course Name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <AutoCompleteField
                      id="courseId"
                      options={courses?.filter(
                        (item: any) => item.status === "ACTIVE"
                      )}
                      optionLabel={"courseName"}
                      onChange={onCourseChange}
                      value={selectedCourse}
                      disableClearable={selectedCourse !== "" ? false : true}
                      required={true}
                      validState={validStateCourse}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Branch name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <AutoCompleteField
                      id="branchId"
                      options={filteredBranchList}
                      optionLabel={"branchName"}
                      onChange={onBranchChange}
                      value={selectedBranch}
                      disableClearable={selectedBranch !== "" ? false : true}
                      required={true}
                      validState={validStateBranch}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>

                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Batch Name
                    </div>
                    <AutoCompleteField
                      id="batchId"
                      options={filteredBatches}
                      optionLabel={"batchName"}
                      onChange={onBatchChange}
                      value={selectedBatch}
                      disableClearable={selectedBatch !== "" ? false : true}
                      // required={true}
                      validState={true}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Stage
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <FormControl
                      size="small"
                      fullWidth
                      sx={{ marginBottom: "12px" }}
                    >
                      <Select
                        onChange={onStageChange}
                        value={stage}
                        sx={{
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "5px",
                          },
                        }}
                        disabled={!hasContactsAccess}
                      >
                        {leadStages
                          ?.filter(
                            (stage: any) => stage.stateName !== "CONVERTED"
                          )
                          ?.map((stage: any) => (
                            <MenuItem
                              key={stage.id}
                              value={stage}
                              sx={{
                                color: "#667085",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              {stage.displayStateName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Source
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <SourceManager
                      sourceList={sourceList}
                      onSourceChange={onSourceChange}
                      source={source}
                      page={"CONTACT_CARD"}
                      addLead={true}
                      disabled={true}
                      validSource={isValidSource}
                      contactSource={
                        contactById?.enquirySource
                          ? contactById?.enquirySource === "Excel Import"
                            ? "EXCEL_IMPORT"
                            : contactById?.enquirySource
                          : ""
                      }
                    />
                  </div>
                  <div
                    className={styles.contactFieldSplitItem}
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <div className={styles.contactFieldSplitItemSub}>
                      <div className={styles.viewContactFieldLabel}>
                        Assignee{" "}
                        <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                          *
                        </span>
                      </div>
                      <UserAssign
                        users={combinedAssignees}
                        isForEnquiryModal={true}
                        handleLeadAssignee={handleLeadAssignee}
                        selectedAssignyId={assigny?.id}
                        size="xl"
                        disabled={!hasContactsAccess}
                      />
                    </div>
                    <div className={styles.contactFieldSplitItemSub}>
                      <div className={styles.viewContactFieldLabel}>
                        Priority{" "}
                        <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                          *
                        </span>
                      </div>
                      <FlagAssign
                        isForEnquiryModal={true}
                        handleLeadPriority={handleLeadPriority}
                        selectedPriority={priority}
                        size="xl"
                        disabled={!hasContactsAccess}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  {instituteDetails?.addLeadFormEnabled &&
                    additionalFields?.length > 0 && (
                      <AdditionalFields
                        fields={additionalFields}
                        onFieldChange={handleFieldChange}
                        fieldSplit={true}
                      />
                    )}
                </div>
              </div>

              <div className={styles.contactBtnSplit}>
                <CancelBtn onClick={onClose} />
                <SaveBtn
                  onClick={AddLead}
                  loader={convertToLeadLoading}
                  disabled={convertToLeadLoading || !hasContactsAccess}
                />
              </div>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default ViewContact;
